// import React, { useState } from "react";

// // Importing the images
// import Tab1Image from "../img/envision/communication/cards/shutterstock_2205039653.webp";
// import Tab2Image from "../img/envision/communication/cards/shutterstock_2233770319.webp";
// import Tab3Image from "../img/envision/communication/cards/shutterstock_2247371259.jpg";
// import Tab4Image from "../img/envision/communication/cards/shutterstock_2310609025.jpg";
// import Tab5Image from "../img/envision/communication/cammunicationbanner.JPG";
// // import Tab6Image from "../img/envision/automobilitytab/shutterstock_2450817821.jpg";

// // Importing Font Awesome icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faCar, 
//     faTruck, 
//     faMotorcycle, 
//     faCogs, 
//     faGear, 
//     faSlidersH, 
//     faGlobe,
//     faMicrochip, 
//     faWrench, 
//     faScrewdriver, 
//     faBattery, 
//     faBolt, 
//     faWifi, 
//     faDatabase,
//     faCloud, 
//     faNetworkWired, 
//     faDesktop, 
//     faLaptop, 
//     faTablet, 
//     faVial,   // Added faVial for testing
//     faLaptopCode, // Added faLaptopCode for Digital Technology
//   } from "@fortawesome/free-solid-svg-icons";
// const Communicationverticaltabs = () => {
//   const [activeTab, setActiveTab] = useState("tab1");

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   const styles = {
//     container: {
//       fontFamily: "Arial, sans-serif",
//       display: "flex",
//       width: "80%",
//       margin: "50px auto",
//     },
//     tabNav: {
//       display: "flex",
//       flexDirection: "column",
//       width: "200px",
//       borderRight: "2px solid #fff",
//     },
//     tabButton: {
//       padding: "20px 20px",
//       cursor: "pointer",
//       border: "none",
//       background: "none",
//       fontSize: "16px",
//       fontWeight: "bold",
//       color: "#555",
//       outline: "none",
//       transition: "color 0.3s, background-color 0.3s",
//       borderRadius: "23px",
//       margin: "5px 0",
//       backgroundColor: "#f0f0f0",
//     },
//     activeTabButton: {
//       backgroundColor: "#009ca5",
//       color: "#fff",
//     },
//     tabContent: {
//       padding: "0px",
//       flexGrow: 1,
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "flex-end",
//       alignItems: "center",
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       // backgroundAttachment: "fixed",
//       borderRadius: "23px",
//       height: "430px",
//       color: "#fff",
//       textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
//     },
//     contentBox: {
//       backgroundColor: "rgb(0 156 165)",
//       padding: "20px",
//       borderRadius: "20px",
//       width: "100%",
//       textAlign: "center",
//     },
//     icon: {
//       marginRight: "10px",
//       color: "#fff",
//       fontSize: "24px",
//     },
//   };

//   const getTabBackgroundImage = () => {
//     switch (activeTab) {
//       case "tab1":
//         return `url(${Tab1Image})`;
//       case "tab2":
//         return `url(${Tab2Image})`;
//       case "tab3":
//         return `url(${Tab3Image})`;
//       case "tab4":
//         return `url(${Tab4Image})`;
//       case "tab5":
//         return `url(${Tab5Image})`;
  
//       default:
//         return "none";
//     }
//   };

//   return (
//     <div>
//       <h1 style={{ textAlign: "center" }}>
//         <span style={{ color: "rgb(5 133 158)" }}>Our Expertise in</span> Automotive Solutions
//       </h1>
//       <div style={styles.container}>
//         <div style={styles.tabNav}>
//           <button
//             style={{
//               ...styles.tabButton,
//               ...(activeTab === "tab1" ? styles.activeTabButton : {}),
//             }}
//             onClick={() => handleTabClick("tab1")}
//           >
//             VISMON
//           </button>
//           <button
//             style={{
//               ...styles.tabButton,
//               ...(activeTab === "tab2" ? styles.activeTabButton : {}),
//             }}
//             onClick={() => handleTabClick("tab2")}
//           >
//              Smart FTTx Solutions
//           </button>
//           <button
//             style={{
//               ...styles.tabButton,
//               ...(activeTab === "tab3" ? styles.activeTabButton : {}),
//             }}
//             onClick={() => handleTabClick("tab3")}
//           >
//             Wireless Network Transformation
//           </button>
//           <button
//             style={{
//               ...styles.tabButton,
//               ...(activeTab === "tab4" ? styles.activeTabButton : {}),
//             }}
//             onClick={() => handleTabClick("tab4")}
//           >
//             Smart CapEx Management
//           </button>
//           <button
//             style={{
//               ...styles.tabButton,
//               ...(activeTab === "tab5" ? styles.activeTabButton : {}),
//             }}
//             onClick={() => handleTabClick("tab5")}
//           >
//              Networks
//           </button>
          
//         </div>

//         <div style={{ ...styles.tabContent, backgroundImage: getTabBackgroundImage() }}>
//           <div style={styles.contentBox}>
//             {activeTab === "tab1" && (
//               <p>
//                 <FontAwesomeIcon icon={faCar} style={styles.icon} />
//                 <FontAwesomeIcon icon={faTruck} style={styles.icon} />
//                 <FontAwesomeIcon icon={faGear} style={styles.icon} />
//                 <br></br>
//                  Vehicle Engineering.
//               </p>
//             )}
//             {activeTab === "tab2" && (
//               <p>
//                 <FontAwesomeIcon icon={faMicrochip} style={styles.icon} />
//                 <FontAwesomeIcon icon={faSlidersH} style={styles.icon} />
//                 <FontAwesomeIcon icon={faWifi} style={styles.icon} />

//                 <br></br>
//                  Sensor Design.
//               </p>
//             )}
//             {activeTab === "tab3" && (
//               <p>
//                 <FontAwesomeIcon icon={faCogs} style={styles.icon} />
//                 <FontAwesomeIcon icon={faCloud} style={styles.icon} />
//                 <FontAwesomeIcon icon={faWifi} style={styles.icon} /><br></br>
//                  Embedded Engineering.
//               </p>
//             )}
//             {activeTab === "tab4" && (
//               <p>
//                 <FontAwesomeIcon icon={faVial} style={styles.icon} />
//                 <FontAwesomeIcon icon={faTablet} style={styles.icon} />
//                 <FontAwesomeIcon icon={faWifi} style={styles.icon} /><br></br>
//                  Test Factory.
//               </p>
//             )}
//             {activeTab === "tab5" && (
//               <p>
//                 <FontAwesomeIcon icon={faNetworkWired} style={styles.icon} />
//                 <FontAwesomeIcon icon={faDesktop} style={styles.icon} />
//                 <FontAwesomeIcon icon={faLaptop} style={styles.icon} /><br></br>
//                  Private Networks.
//               </p>
//             )}
           
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Communicationverticaltabs;




import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/communication/telecom.jpg";
import Tab2Image from "../img/envision/communication/cards/shutterstock_2233770319.webp";
import Tab3Image from "../img/envision/communication/information act.jpg";
import Tab4Image from "../img/envision/communication/cards/shutterstock_2310609025.jpg";
import Tab5Image from "../img/envision/communication/cammunicationbanner.JPG";

import Tab6Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Communicationverticaltabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay


    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    // const handleKnowMoreClick = () => {
    //     // Navigate to the documentaerospacepage with the specific hash
    //     navigate("/documentCommunicationPage#documentCommunicationPageone");
    //   };


    const handleKnowMoreClick = (tabId) => {
        console.log("Navigating to:", tabId);
        navigate(`/documentCommunicationPage?activeTab=${tabId}#documentCommunicationPageone`);
      
        setTimeout(() => {
          const targetElement = document.getElementById("documentCommunicationPageone");
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 700);
      };
      
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
      };
     // Autoplay effect to change tabs every 3 seconds (3000ms)
     useEffect(() => {
        let tabInterval;
    
        if (!isHovered && isAutoPlayActive) {
          tabInterval = setInterval(() => {
            setActiveTab((prevTab) => {
              const nextTabNum = parseInt(prevTab.replace("tab", "")) % 4 + 1;
              return `tab${nextTabNum}`;
            });
          }, 3000);
        }
    
        return () => clearInterval(tabInterval);
      }, [activeTab, isHovered, isAutoPlayActive]);
    

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {

            flexDirection: "column",
            borderRight: "1px solid #fff",
            // height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
            cursor:"pointer"
        },
        image: {
            width: "382px",
            height: "274px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            height:"290px",
            overflowY:"auto"
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>Regulatory Compliance</span> Services
            </h1>
            <div style={styles.container} className="tabclass-container-data">
                <div style={styles.tabNav} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                      Telecom Cyber Security Regulations, 2024
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                        National Critical Information Infrastructure Protection Centre (NCIIPC) Guidelines
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab3") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab3") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                       Information Technology Act, 2000 (Amended 2008)
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab4") {
                              e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                              e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "tab4") {
                              e.currentTarget.style.backgroundColor = ""; // Revert background
                              e.currentTarget.style.color = ""; // Revert text color
                            }
                          }}
                      
                    >
                       Digital Personal Data Protection (DPDP) Act, 2023
                    </button>
                   
                  

                </div>

                <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image,}[activeTab]}
                        alt="Healthcare"
                        style={styles.image}
                        className="tab-image-data"
                    />
                      <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    "Mandatory annual IT audits to validate:",
                                    " Appointment of a Chief Telecom Security Officer (CTSO) to oversee cybersecurity initiatives.",
                                    "Implementation of robust network security measures to protect against cyber threats.",
                                    "Establishment of protocols for incident reporting and response mechanisms.",
                                    "Compliance with specified timelines for addressing security vulnerabilities.",
                                    
                                ],
                                [
                                    "Mandatory annual IT audits to validate:",
                                    "Identification and protection of critical assets within the telecom infrastructure.",
                                    "Implementation of risk management strategies to mitigate potential threats.",
                                    "Development of incident response plans tailored to critical infrastructure scenarios.",
                                    "Regular vulnerability assessments and penetration testing to ensure system integrity.",
                                   
                                ],
                                [
                                    "Mandatory annual IT audits to validate:",
                                    "Legal recognition of electronic records and digital signatures.",
                                    "Definition and penalization of various cybercrimes, including unauthorized access and data breaches.",
                                    "Establishment of a framework for data protection and privacy.",
                                    "Provision for the appointment of a Controller of Certifying Authorities to regulate digital signatures.",
                                ],
                                [
                                    "Mandatory annual IT audits to validate:",
                                    "Obligation to obtain explicit consent from individuals before processing their personal data.",
                                    "Implementation of measures to ensure data security and prevent breaches.",
                                    "Adherence to data localization requirements, ensuring that certain sensitive data remains within India's borders.",
                                   
                                  ],
                             
                            ];

                            // Ensure the selected content is within range and not undefined
                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((point, index) => (
                                <ul key={index}>
                                    <li>{point}</li>
                                </ul>
                            ));
                        })()}

                        {/* <button
                            style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                            onClick={handleKnowMoreClick}
                        className="know-more-btn"
                        >
                            Know More
                        </button> */}
                         {Array.from({ length: 4 }, (_, index) => {
              const tabId = `tab${index + 1}`;
              return (
                activeTab === tabId && (
                  <button key={tabId} onClick={() => handleKnowMoreClick(tabId)}
                    style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                    className="know-more-btn"
                  >
                    Know More
                  </button>
                )
              );
            })}
                    </div>
                </div>
            </div>

            {/* Dot Navigation */}
            <div style={styles.dotNav}>
                {[...Array(4)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Communicationverticaltabs;

